import {ArrayFilterHelpers} from './array';
import {DateFilterHelpers} from './date';
import {PropertyFilterHelpers} from './property';
import {ValueFilterHelpers} from './value';

export const Filters = {
  array: ArrayFilterHelpers,
  value: ValueFilterHelpers,
  date: DateFilterHelpers,
  property: PropertyFilterHelpers,
};
